import { Divider, Stack } from '@mui/material';
import { ReferenceProperties } from '@/modules/referenceImage/UI/components';
import { PointCloudProperties } from '@/modules/pointCloud';

import { FloorPlanProperties } from './FloorPlanProperties';

export function PropertyPanel() {
  return (
    <Stack spacing={1} style={propertiesPanelStyle} divider={<Divider />} className='overflowHidden'>
      <ReferenceProperties />
      <PointCloudProperties />
      <FloorPlanProperties />
    </Stack>
  );
}

const propertiesPanelStyle = {
  boxShadow: 'none',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 8,
} as const;
